const message = {
  notAllowedChangeComponent: 'Please save before moving to different component.',
  notAllowedCloseAutomation: 'Please save before moving closing automation.',
  closeAutomationModalConfirmation: 'Are you sure you want to close? All changes will not be saved.'
}

export default message;